var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-message"},[_vm._t("default",function(){return [_vm._v("There was an error loading the requested data.")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }